export default "__VITE_ASSET__D4x_G_i6__"